import script from "./mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__